import React from 'react';
import { Box } from '@mui/system';
import pxToEm from 'theme/pxToEm';
import * as Styled from '../SearchAutocompleteResults.styles';

interface SleletonProps {
  shouldShowDividers?: boolean;
  shouldShowImages: boolean;
}
export const SkeletonContainer: React.FC<SleletonProps> = ({
  shouldShowDividers,
  shouldShowImages,
}) => {
  return (
    <Box>
      {Array.from({ length: 5 }).map((_, index) => (
        <React.Fragment key={index}>
          {shouldShowDividers && index !== 0 && <Styled.RowDivider />}
          <Styled.RowContainer>
            {shouldShowImages && (
              <Styled.SkeletonImageContainer overflow="hidden">
                <Styled.SkeletonLine
                  height={48}
                  width={48}
                  key={index}
                ></Styled.SkeletonLine>
              </Styled.SkeletonImageContainer>
            )}

            <Box
              display="flex"
              flexDirection="column"
              rowGap={pxToEm(4)}
              flexGrow={1}
            >
              <Styled.SkeletonLine height={22} width={`${25 + index * 10}%`} />
            </Box>
            <Styled.ArrowWrapper>
              <Styled.SkeletonArrow width={24} height={24} />
            </Styled.ArrowWrapper>
          </Styled.RowContainer>
        </React.Fragment>
      ))}
    </Box>
  );
};
